import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { throwError, Observable, BehaviorSubject, finalize } from "rxjs";
import { catchError, filter, take, switchMap } from "rxjs/operators";
import { AuthServerProvider } from "../auth/auth-jwt.service";
import { Router } from '@angular/router';
import { Principal } from '../auth/principal.service';
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private refreshTokenInProgress = false;
  private isLoggingOut = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public auth: AuthServerProvider, private router: Router,private principal: Principal) {
        this.auth.resetInterceptorState = () => this.reset();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addAuthenticationToken(request);

    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {

      if (request.url.includes('/api/public/shared-flow-links/')) {
        return throwError(error);
      }

      if (this.isLoggingOut) return throwError(error);

      if (request.url.includes("login") ||
          request.url.includes("refresh-token") ||
          request.url.includes("logout")) {
        if (error.status === 401) {
            this.auth.clearLocalStorage();
            this.principal.authenticate(null);
            this.router.navigate(['/login']);
        }
        return throwError(error);
      }

      if (error.status !== 401) {
        return throwError(error);
      }

      if (this.refreshTokenInProgress) {
        return this.refreshTokenSubject.pipe(
          filter(result => result !== null),
          take(1),
          switchMap(() => next.handle(this.addAuthenticationToken(request)))
        );
      } else {
        this.refreshTokenInProgress = true;
        this.refreshTokenSubject.next(null);

        return this.auth.refreshToken().pipe(
          switchMap((token: any) => {
            this.refreshTokenInProgress = false;
            this.isLoggingOut = false;
            this.refreshTokenSubject.next(token);
            return next.handle(this.addAuthenticationToken(request));
          }),
          finalize(() => (this.refreshTokenInProgress = false)),
          catchError((err: any) => {
            this.refreshTokenInProgress = false;
            this.isLoggingOut = true;
            this.auth.logout().subscribe({
                complete: () => {
                    this.principal.authenticate(null);
                    this.router.navigate(['/login']);
                },
                error: () => {
                    this.auth.clearLocalStorage();
                    this.principal.authenticate(null);
                    this.router.navigate(['/login']);
                }
            });
            return throwError(error);
        })
        );
      }
    })) as Observable<HttpEvent<any>>;
  }

  addAuthenticationToken(request: any) {
    const accessToken = this.auth.getToken();
    if (!accessToken) {
      return request;
    }
    return request.clone({
      withCredentials: true,
      setHeaders: {
        Authorization: 'Bearer ' + accessToken
      }
    });
  }
  reset() {
      this.refreshTokenInProgress = false;
      this.isLoggingOut = false;
      this.refreshTokenSubject = new BehaviorSubject<any>(null);
  }
}
